/* Casca Rija: respect Shopify consent; never record consent automatically. */
(function (window, document) {
  'use strict';
  var loaded = false;
  function update() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    var analytics = Boolean(api && api.analyticsProcessingAllowed());
    var marketing = Boolean(api && api.marketingAllowed());
    window.gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });
    // This existing container mixes analytics and marketing: require both.
    if (analytics && marketing && !loaded) {
      loaded = true;
      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      var script = document.createElement('script');
      script.async = true;
      script.id = 'cascarija-consented-gtm';
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PVSVWMF';
      document.head.appendChild(script);
    }
  }
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-cr-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      var status = document.getElementById('cascarija-cookie-status');
      var messages = document.querySelector('script[data-cr-consent-bridge]');
      if (status && messages) status.textContent = messages.getAttribute('data-preferences-loading') || '';
    }
  });
  function ready() {
    var attempts = 0;
    function check() {
      if (window.Shopify && window.Shopify.customerPrivacy) { update(); return; }
      if (++attempts < 50) window.setTimeout(check, 200);
    }
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})(window, document);
/* Casca Rija: decorative Judge.me icon accessibility repair. */
(function (window, document) {
  'use strict';
  function fixDecorativeJudgeMeIcons() {
    document.querySelectorAll('.jdgm-favicon img:not([alt])').forEach(function (image) {
      image.setAttribute('alt', '');
      image.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (frame) {
      var src = frame.getAttribute('src') || '';
      var messages = document.querySelector('script[data-cr-consent-bridge]');
      var title = messages && messages.getAttribute(src.indexOf('merchantverse') !== -1 ? 'data-google-reviews-title' : 'data-embedded-content-title');
      if (title) frame.setAttribute('title', title);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDecorativeJudgeMeIcons);
  } else {
    fixDecorativeJudgeMeIcons();
  }
  document.addEventListener('jdgm.doneSetup', fixDecorativeJudgeMeIcons);
  [1000, 3000, 6000, 10000].forEach(function (delay) {
    window.setTimeout(fixDecorativeJudgeMeIcons, delay);
  });
})(window, document);
